<div class="flexable !mt-2 flex gap-1 p-2 rounded-xl  !text-[13px] text-black">
  <div class="rounded-tab flex gap-x-1 p-2 pl-12">
    <div class="col-span-12 md:col-span-3 w-full flex gap-1 items-center">
      <div class="">
     
<select [(ngModel)]="filtering.warehouse" (ngModelChange)="onFilterChange($event, 'warehouse')">
  <option *ngFor="let warehouse of warehouses$ | async" [value]="warehouse.uniqueId">
    {{ warehouse.name }}
  </option>
</select>
      </div>
    </div>

    @if (filtering.warehouse && (warehouseSensors$ | async)?.length) {
    <div class="col-span-12 md:col-span-3 w-full flex gap-1 items-center">
      <div class="flex gap-1 items-center w-full">
       <mat-form-field appearance="outline">
  <mat-label>Select Sensor</mat-label>
  <mat-select [(ngModel)]="filtering.sensor">
    <mat-option *ngFor="let sensor of warehouseSensors$ | async" [value]="sensor.uniqueId">
      {{ sensor.sensorName }}
    </mat-option>
  </mat-select>
</mat-form-field>

        <div *ngIf="filtering.sensor">
          <span
            (click)="filtering.sensor = null"
            class="pr-2.5 hover:bg-gray-300 cursor-pointer flex items-center rounded-full bg-gray-200 text-xs"
          >
            <mat-icon class="scale-50">clear</mat-icon> Clear
          </span>
        </div>
      </div>
    </div>
    }

    <div class="col-span-12 md:col-span-3 w-full flex gap-1 items-center">
      <div class="flex gap-2 items-center w-full">
      
     <select [(ngModel)]="filtering.alertType">
  <option *ngFor="let type of alertTypes" [value]="type.value">
    {{ type.name?.replaceAll("_", " ") }}
  </option>
</select>
        <div *ngIf="filtering.alertType">
          <span
            (click)="filtering.alertType = null"
            class="pr-2.5 hover:bg-gray-300 cursor-pointer flex items-center rounded-full bg-gray-200 text-xs"
          >
            <mat-icon class="scale-50">clear</mat-icon> Clear
          </span>
        </div>
      </div>
    </div>

    <div class="col-span-12 md:col-span-3 w-full flex gap-4 items-center">
      <div class="flex gap-2 items-center w-full">
     
       <select [(ngModel)]="filtering.status">
  <option value="RESOLVED">Resolved</option>
  <option value="UNRESOLVED">Unresolved</option>
</select>
        <div *ngIf="filtering.status">
          <span
            (click)="filtering.status = null"
            class="pr-2.5 hover:bg-gray-300 cursor-pointer flex items-center rounded-full bg-gray-200 text-xs"
          >
            <mat-icon class="scale-50">clear</mat-icon> Clear
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="flex gap-4 items-center rounded-tab w-fit p-2">
    <span class="text-black">Timeframe: </span>
    <div class="flex items-center gap-1">
      @for (tab of timeframeTabs; track tab) { @if (tab?.name ===
      activeTimeframeTab) {
    
      <span class="!bg-[#3A7AA8] !text-white !px-[12px] rounded-full !py-[8px]">
        <span class="text-white text-[13px] relative">{{ tab?.name }}</span>
      </span>
      } @else {
    
      <span
        (click)="
          activeTimeframeTab = tab?.name; onFilterChange(tab?.name, 'timeframe')
        "
        class="!cursor-pointer !border border-[#3A7AA8] px-[12px] py-[8px] rounded-full text-[#3A7AA8]"
        >{{ tab?.name }}</span
      >
      } } @if (activeTimeframeTab) {
     
      <div
        (click)="
          activeTimeframeTab = null;
          filtering.dateTo = null;
          filtering.dateFrom = null
        "
        class="!cursor-pointer !border border-[#3A7AA8] px-[12px] py-[8px] rounded-full text-[#3A7AA8] !w-fit flex !min-w-[132px] gap-1"
      >
        <fa-icon [icon]="faCalendar"></fa-icon>
        <span>Custom Date</span>
      </div>
      } @else {
    
      <span
        class="!cursor-pointer !bg-[#3A7AA8] !px-[12px] rounded-full !py-[8px] !min-w-[132px] gap-1"
      >
        <span class="text-white !text-[13px]">
          <fa-icon [icon]="faCalendar"></fa-icon>
          Custom Date
        </span>
      </span>
      }

      <div class="flex gap-1"
          [ngStyle]="{ display: activeTimeframeTab ? 'none' : '' }">
    
        <div class="custom-date-input-container">
          <input
            type="text"
            class="custom-date-input"
            [max]="endDate"
            [(ngModel)]="startDate"
            (dateChange)="onFilterChange(null, 'dateFrom')"
            [disabled]="activeTimeframeTab"
            [matDatepicker]="startDatePicker"
            placeholder="Select Start Date"
            readonly
            (click)="startDatePicker.open()"
          />
          <button
            class="calendar-button"
            mat-icon-button
            [disabled]="activeTimeframeTab"
            (click)="startDatePicker.open()"
          >
            <img src="assets/icons/calendar-02.png" alt="" srcset="" />
          </button>
          <mat-datepicker #startDatePicker></mat-datepicker>
        </div>
        <div class="custom-date-input-container">
          <input
            type="text"
            class="custom-date-input"
            [(ngModel)]="endDate"
            [min]="startDate"
            (dateChange)="onFilterChange(null, 'dateTo')"
            [disabled]="activeTimeframeTab"
            [matDatepicker]="endDatePicker"
            placeholder="Select End Date"
            readonly
            (click)="endDatePicker.open()"
          />
          <button
            class="calendar-button"
            mat-icon-button
            [disabled]="activeTimeframeTab"
            (click)="endDatePicker.open()"
          >
            <img src="assets/icons/calendar-02.png" alt="" srcset="" />
          </button>
          <mat-datepicker #endDatePicker></mat-datepicker>
        </div>
      </div>
    </div>
  </div>

  <div class="flex justify-end col-span-12">
    <button
      (click)="generateReport()"
      class="rounded-full py-[8px] px-[12px] flex gap-2 text-[13px] font-normal bg-[#dbdbdb] text-[#9b9b9b]"
      [ngClass]="{
        '!bg-[#025590] !text-white': filtering.warehouse && filtering.warehouse !== 'null',
        ' cursor-not-allowed': !filtering.warehouse && filtering.warehouse === 'null'
      }" [disabled]="!filtering.warehouse || filtering.warehouse === 'null'"
    >
      Generate
    </button>
  </div>
</div>

<div class="mt-8">
  <app-pdf-viewer
    *ngIf="reportData"
    class="w-full"
    [base64Src]="reportData"
    [filenameForDownload]="'Alert Report'"
  ></app-pdf-viewer>
</div>
